import request from '@/utils/request'

// 获取平台类目
export function getClassifyList(params) {
  return request({
    url: '/api/z/category/getCategoryList',
    method: 'post',
    params
  })
}
// 获取热门分类
export function getHotClassifyList(params) {
  return request({
    url: '/api/z/category/getHotList',
    method: 'post',
    params
  })
}



// WEBPACK FOOTER //
// ./src/api/category.js